import { render, staticRenderFns } from "./BattleCarousel.vue?vue&type=template&id=3ede64bf&"
import script from "./BattleCarousel.vue?vue&type=script&lang=ts&"
export * from "./BattleCarousel.vue?vue&type=script&lang=ts&"
import style0 from "./BattleCarousel.vue?vue&type=style&index=0&id=3ede64bf&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports